// extracted by mini-css-extract-plugin
export default {"wrapper":"AudioInputVerification_wrapper__VFdnS","canvasWrapper":"AudioInputVerification_canvasWrapper__viAPa"};